/*                                                                                         */
/*                                                                                          */
/*                                                                                         */
/*                                                                                           */
/*                                                                                 */
/*                                                                                     */
/*                                                                                         */
/*                                                                                      */
/*                                   */
import ky from "ky";
import { isHTTPError } from "@otto-ec/global-resources/ky";
import { createLogger, kyTimeoutLoggingHook } from "utils/logging";
import type { FetchRetryArgs } from "./fetch.ts";

const RETRY_ON_METHODS = ["get", "post", "put", "query"];

function handleError(error: unknown) {
	if (isHTTPError(error)) {
		return error.response;
	}
	throw error;
}

export async function kyFetch(args: FetchRetryArgs): Promise<Response> {
	const {
		url,
		namespace,
		timeout,
		retryOptions: { limit },
		fetchOptions,
	} = args;

	const logger = createLogger(namespace, "fetch-retry");

	return await ky(url, {
		retry: { limit, retryOnTimeout: true, methods: RETRY_ON_METHODS },
		timeout: timeout ?? false,
		hooks: {
			beforeError: [kyTimeoutLoggingHook(logger, url)],
		},
		...fetchOptions,
	}).catch(handleError);
}
